module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fzg-chuangtou-pc"
  }, [_c('div', {
    staticClass: "fzg-banner"
  }, [_c('fzg-menu'), _vm._v(" "), _c('div', {
    staticClass: "sologan"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ct-intro"
  }, [_c('img', {
    staticClass: "tou-title",
    attrs: {
      "src": require("../../assets/img2/pc/chuangtou/title-ct.png"),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "tou-list"
  }, [_vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _vm._m(3, false, false), _vm._v(" "), (false) ? _c('div', {
    staticClass: "tou-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/chuangtou/icon4.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("管理细则")]), _vm._v(" "), _vm._m(4, false, false)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "fzg-ct-case-list"
  }, [_c('img', {
    staticClass: "case-title",
    attrs: {
      "src": require("../../assets/img2/pc/chuangtou/title-al.png")
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "bus-wrap"
  }, [_vm._l((_vm.invest_case_list), function(item) {
    return _c('li', {
      staticClass: "bus-item"
    }, [_c('div', {
      staticClass: "cover"
    }, [_c('div', {
      staticClass: "cover-content"
    }, [_vm._v(" " + _vm._s(item.brief) + " ")])]), _vm._v(" "), _c('img', {
      staticClass: "logo",
      attrs: {
        "src": item.logo,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])])
  }), _vm._v(" "), (false) ? [_vm._m(5, false, false)] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "fzg-company-list"
  }, [_vm._m(6, false, false), _vm._v(" "), _c('div', {
    staticClass: "fzg-company-list-wrap"
  }, [_vm._l((_vm.invest_company_list), function(item, index) {
    return (_vm.isShowMoreCompany ? true : index < 7) ? _c('div', {
      staticClass: "fzg-company-list-item-wrap",
      class: {
        'active-company': _vm.activeCompanyId == item.id
      }
    }, [_c('div', {
      staticClass: "fzg-citem",
      on: {
        "click": function($event) {
          _vm.activeCompanyId = item.id
        }
      }
    }, [_c('div', {
      staticClass: "citem-name"
    }, [_c('div', {
      staticClass: "c-title"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _vm._v(" "), (_vm.activeCompanyId == item.id) ? _c('img', {
      staticClass: "right-icon",
      attrs: {
        "src": require("../../assets/img2/pc/chuangtou/icon-close.png")
      }
    }) : _c('img', {
      staticClass: "right-icon",
      attrs: {
        "src": require("../../assets/img2/pc/chuangtou/icon-add.png")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "c-item-content"
    }, [_c('div', {
      staticClass: "c-item-image"
    }, [_c('img', {
      attrs: {
        "src": item.logo
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "c-item-intro"
    }, [_c('p', [_vm._v(_vm._s(item.brief))]), _vm._v(" "), _c('div', {
      staticClass: "c-item-link"
    }, [_c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_vm._v(" 查看企业 ")])])])])])]) : _vm._e()
  }), _vm._v(" "), (!_vm.isShowMoreCompany) ? _c('div', {
    staticClass: "check-more",
    on: {
      "click": function($event) {
        _vm.isShowMoreCompany = true
      }
    }
  }, [_vm._v(" 更多 ")]) : _vm._e()], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tou-intro"
  }, [_c('p', [_vm._v("小饭桌创投（原：凡创资本）是凡卓集团旗下直投基金。")]), _vm._v(" "), _c('p', [_vm._v("自2018年成立以来，小饭桌创投坚持投资于为社会创造真实价值的早期创业企业，陪伴创业者从平凡到卓越。投资领域主要是 "), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("新经济领域以及国家战略性产业（如工业科技、新科技、新能源、生物医药等）")]), _vm._v("，投资案例包含企迈科技、E签宝、圈量科技、爱数智慧、保碧新能源、禾电科技、1号职场、inse、中科氢易、脉络能源、大方智能、增广智能等。")]), _vm._v(" "), _c('p', [_vm._v("小饭桌创投聚焦早期科技投资，管理基金规模逾15亿人民币。投资团队来自北大、清华、人大、LSE等知名高校，拥有丰富的早期投资经验。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tou-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/chuangtou/icon1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("基金定位")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n          以小饭桌创投生态为基础"), _c('br'), _vm._v("\n          以地方优势产业为引导\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tou-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/chuangtou/icon2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("投资策略")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n          围绕前沿技术"), _c('br'), _vm._v("\n          聚焦大健康、先进制造、"), _c('br'), _vm._v("\n          新能源新材料领域\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tou-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/chuangtou/icon3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("基金优势")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n          聚焦早期投资（种子～Pre-A）"), _c('br'), _vm._v("\n          单笔金额500-1000万人民币\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._v("\n          政府全额出资，管理费用落地后置"), _c('br'), _vm._v("\n          Carry市场化分成\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "bus-item"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('div', {
    staticClass: "cover-content"
  }, [_vm._v(" 新一代经营门店经营系统，助力商家数字化升级 ")])]), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/chuangfu/logo10.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("人才对接")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-list-title"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img2/pc/chuangtou/title-bt.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f58e90f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/investment/FzgChuangTouPc.vue
// module id = 247
// module chunks = 0